import { Routes } from '@angular/router';

import { CamGridRowCommonMetaDataService } from '@camelot/core';
import { CamRoutes } from '@camelot/menu';
import { CamVatLevelsService, CamVatLevelsVisitorService } from '@camelot/services';

import { AppQuotationGridMetaDataService } from 'src/app/services/billings/quotation-grid-metadata.service';

export enum EBillingsVisitorRoute {
  billing = 'visitor-billings',
  view = 'view',
}

CamRoutes.addRoute({
  key: EBillingsVisitorRoute.billing,
  url: 'visitor-billings',
  children: [
    {
      key: EBillingsVisitorRoute.view,
      url: 'view/:version',
    },
  ],
});

export const visitorBillingsRoutes: Routes = [
  {
    path: CamRoutes.getUrl([EBillingsVisitorRoute.billing, EBillingsVisitorRoute.view]),
    loadComponent: () =>
      import('./pages/visitor-quotation-view/visitor-quotation-view.component').then(c => c.VisitorQuotationViewPage),
    // Les niveaux de TVA de la grille passent par le client visiteur : les services de métadonnées sont réinstanciés ici pour l'injecter.
    providers: [
      AppQuotationGridMetaDataService,
      CamGridRowCommonMetaDataService,
      { provide: CamVatLevelsService, useClass: CamVatLevelsVisitorService },
    ],
  },
];
